export default [
    {
      count: 1,
      msg: 'Have a nice day!',
      time: '2022-01-30T08:01:46.356Z'
    },
    {
        count: 2,
        msg: 'Nyanpasu!',
        time: '2022-01-30T08:03:10.862Z'
    },
  ]